/* eslint-disable */
export enum PermissionVerbsV2 {
  EDIT_WORKSPACE = 'EditWorkspace',
  DELETE_WORKSPACE = 'DeleteWorkspace',
  ARCHIVE_WORKSPACE = 'ArchiveWorkspace',
  VIEW_WORKSPACE_ELEMENT_CONFIGURATION = 'ViewWorkspaceElementConfiguration',
  CONFIGURE_WORKSPACE_ELEMENTS = 'ConfigureWorkspaceElements',
  VIEW_ALL_WORKSPACES = 'ViewAllWorkspaces',
  MANAGE_ALL_WORKSPACES = 'ManageAllWorkspaces',
  CONFIGURE_WORKSPACE_PERMISSIONS = 'ConfigureWorkspacePermissions',
  CREATE_WORKSPACE = 'CreateWorkspace',
  CREATE_ELEMENT = 'CreateElement',
  CREATE_DRAFT_ELEMENT = 'CreateDraftElement',
  EDIT_ALL_ELEMENTS = 'EditAllElements',
  EDIT_OWN_ELEMENTS = 'EditOwnElements',
  ARCHIVE_OWN_ELEMENT = 'ArchiveOwnElement',
  DELETE_ALL_ELEMENTS = 'DeleteAllElements',
  DELETE_OWN_ELEMENT = 'DeleteOwnElement',
  DRAFT_OWN_ELEMENT = 'DraftOwnElement',
  VIEW_ARCHIVED_ELEMENT = 'ViewArchivedElement',
  VIEW_DRAFT_ELEMENT = 'ViewDraftElement',
  VIEW_ELEMENT = 'ViewElement',
  CHANGE_STATUS_OF_ALL_ELEMENTS = 'ChangeStatusOfAllElements',
  CREATE_RATING = 'CreateRating',
  EDIT_OWN_RATING = 'EditOwnRating',
  DELETE_OWN_RATING = 'DeleteOwnRating',
  MANAGE_ALL_RATINGS = 'ManageAllRatings',
  VIEW_ALL_RATINGS = 'ViewAllRatings',
  CREATE_COMMENT = 'CreateComment',
  MANAGE_ALL_COMMENTS = 'ManageAllComments',
  VIEW_ALL_COMMENTS = 'ViewAllComments',
  CREATE_ATTACHMENT = 'CreateAttachment',
  DELETE_ATTACHMENT = 'DeleteAttachment',
  CREATE_ROADMAP = 'CreateRoadmap',
  VIEW_ALL_ROADMAP = 'ViewAllRoadmap',
  VIEW_ROADMAP_MODULE = 'ViewRoadmapModule',
  CONFIGURE_ROADMAP_MODULE = 'ConfigureRoadmapModule',
  EDIT_ALL_ROADMAPS = 'EditAllRoadmaps',
  DELETE_ALL_ROADMAPS = 'DeleteAllRoadmaps',
  CONFIGURE_ALL_ROADMAPS = 'ConfigureAllRoadmaps',
  CREATE_SPACE_PRESET = 'CreateSpacePreset',
  EDIT_ALL_SPACE_PRESETS = 'EditAllSpacePresets',
  EDIT_OWN_SPACE_PRESET = 'EditOwnSpacePreset',
  DELETE_ALL_SPACE_PRESETS = 'DeleteAllSpacePresets',
  DELETE_OWN_SPACE_PRESET = 'DeleteOwnSpacePreset',
  CONFIGURE_WORKSPACE_PRESETS = 'ConfigureWorkspacePresets',
  MANAGE_SUBSCRIBED_PUBLIC_PRESETS = 'ManageSubscribedPublicPresets',
  CREATE_INSIGHTS_PRESET = 'CreateInsightsPreset',
  EDIT_INSIGHTS_PRESET = 'EditInsightsPreset',
  DELETE_INSIGHTS_PRESET = 'DeleteInsightsPreset',
  EDIT_ORGANIZATION = 'EditOrganization',
  DEACTIVATE_ORGANIZATION = 'DeactivateOrganization',
  REACTIVATE_ORGANIZATION = 'ReactivateOrganization',
  ADD_USER = 'AddUser',
  MANAGE_ALL_USERS = 'ManageAllUsers',
  VIEW_ALL_WORKSPACE_USERS = 'ViewAllWorkspaceUsers',
  VIEW_ALL_ORGANIZATION_USERS = 'ViewAllOrganizationUsers',
  INVITE_ORGANIZATION_USER = 'InviteOrganizationUser',
  EDIT_ALL_ORGANIZATION_USERS = 'EditAllOrganizationUsers',
  DEACTIVATE_ALL_ORGANIZATION_USERS = 'DeactivateAllOrganizationUsers',
  DELETE_ALL_ORGANIZATION_USERS = 'DeleteAllOrganizationUsers',
  MANAGE_ORGANIZATION_ELEMENT_CONFIGURATION = 'ManageOrganizationElementConfiguration',
  VIEW_SUBSCRIPTION_PLAN = 'ViewSubscriptionPlan',
  MANAGE_SUBSCRIPTION_PLAN = 'ManageSubscriptionPlan',
  VIEW_PERMISSION_CONFIGURATION = 'ViewPermissionConfiguration',
  MANAGE_PERMISSION_CONFIGURATION = 'ManagePermissionConfiguration',
  MANAGE_SSO = 'ManageSSO',
  MANAGE_ALL_INTEGRATIONS = 'ManageAllIntegrations',
  MANAGE_CONTENT_PACKAGE = 'ManageContentPackage',
  MANAGE_SUBMISSIONS = 'ManageSubmissions',
  MANAGE_WORKFLOW = 'ManageWorkflow',
  PIN_SIGNAL = 'PinSignal',
  SHARE_CONTENT = 'ShareContent',
  SHARE_CONTENT_EXTERNALLY = 'ShareContentExternally',
  SHARE_CONTENT_INTERNALLY = 'ShareContentInternally',
  SUBSCRIBE_TO_CONTENT = 'SubscribeToContent',
  SUBSCRIBE_TO_EXTERNAL_CONTENT = 'SubscribeToExternalContent',
  SUBSCRIBE_TO_INTERNAL_CONTENT = 'SubscribeToInternalContent',
  VIEW_BOARD_MODULE = 'ViewBoardModule',
  VIEW_EXPLORER_MODULE = 'ViewExplorerModule',
  VIEW_INSIGHTS_MODULE = 'ViewInsightsModule',
  VIEW_PORTFOLIO_MODULE = 'ViewPortfolioModule',
  VIEW_RADAR_MODULE = 'ViewRadarModule',
  VIEW_NETWORK_GRAPH = 'ViewNetworkGraph',
  RELATE_ALL_ELEMENTS = 'RelateAllElements',
  RELATE_OWN_ELEMENT = 'RelateOwnElement',
  VIEW_AVERAGE_RATINGS = 'ViewAverageRatings',
  EDIT_WORKSPACE_VISIBILITY = 'EditWorkspaceVisibility',
  EXCEL_EXPORT = 'ExcelExport',
  EXCEL_IMPORT = 'ExcelImport',
  UPDATE_ELEMENT_TYPE = 'UpdateElementType',
  VIEW_EXTERNAL_REPORTS = 'ViewExternalReports',
  POWERPOINT_EXPORT = 'PowerPointExport'
}
